export const SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS =
  'SET_PURCHASE_LICENSE_FLOW_GRANT_STATUS';
